import "./navbar.css";

import { Link } from "react-router-dom";

function Navbar() {
  return (
    <div>
      <section className="hide-on-media">
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container">
            <Link className="navbar-brand" to="#"></Link>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mr-auto ">
                <li className="nav-item">
                  <Link className="nav-link" to="/">
                    0813-295-7723
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link className="nav-link" to="/about">
                    ruthifeoluwaoladejo@gmail.com{" "}
                  </Link>
                </li>
              </ul>

              <ul className="navbar-nav ml-auto df">
                <li className="nav-item">
                  <Link className="nav-link" to="/">
                    home
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link className="nav-link" to="/about">
                    about
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/portfolio">
                    portfolio
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </section>
    </div>
  );
}

export default Navbar;
